export const FILTER_POINTS         = 'points'
export const FILTER_QUESTS         = 'quests'
export const FILTER_CATEGORIES     = 'categories'
export const FILTER_TRIANGULATED   = 'triangulated'
